import { Component, OnInit } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterCategory } from '../../shared/models/filter.model';
import { UserService } from '../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterService } from '../../services/filter.service';
import { take } from 'rxjs/operators';
import { PairService } from '../../services/pair.service';
import { IPairOverview } from '../../shared/models/pair-overview.model';
import { RoutableModel } from '../../shared/models/routable.model';
import { FilterDialogComponent } from '../../shared/components/filter-dialog/filter-dialog.component';

@Component({
  selector: 'app-all-flights',
  templateUrl: './all-flights.component.html',
  styleUrls: ['./all-flights.component.scss']
})
export class AllFlightsComponent implements OnInit, RoutableModel {

  backUrl: string = '/home';
  canGoBack: boolean = true;
  pageTitle: string = 'All flights'

  unsubscribe$ = new Subject();
  form: FormGroup;
  pairList: IPairOverview[] = [];
  page = 1;
  hasNextPage = false;
  isBusy = false;

  constructor(private userService: UserService, private modalService: NgbModal, private fb: FormBuilder, private filterService: FilterService, private pairService: PairService) {
    this.filterService.filterDataSubject.value.completedOnly = false;
    this.filterService.filterDataSubject.value.timespan = undefined;
  }


  ngOnInit(): void {
    this.refetchPairs().then(() => {
      this.hasNextPage = this.pairList?.length === 21;
    });
  }



  ngOnDestroy(): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }

  openFilterModal() {
    const modal = this.modalService.open(FilterDialogComponent, {centered: true, ariaLabelledBy: 'modal-basic-title'});
    const modalRef = modal.componentInstance as FilterDialogComponent;
    modal.closed.pipe(take(1)).subscribe(() => {
      this.searchClicked();
    });
    modalRef.filterCategory = FilterCategory.ALL_FLIGHTS;
  }

  searchClicked() {
    this.page = 1;
    this.refetchPairs().then(() => {
      this.hasNextPage = this.pairList?.length === 21;
    });
  }

  nextPage() {
    if (!this.hasNextPage) {
      return;
    }
    this.page++;
    this.refetchPairs().then(() => {
      this.hasNextPage = this.pairList?.length === 21;
    });
  }

  previousPage() {
    if (this.page === 1) {
      return;
    }
    this.hasNextPage = true;
    this.page--;
    this.refetchPairs();
  }

  async refetchPairs() {
    this.isBusy = true;
    this.pairList = [];
    this.pairList = await firstValueFrom(this.pairService.getPairsOverview(this.page)).catch(() => []);
    this.isBusy = false;
  }
}
